import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsImage from "../../components/LdsImage";
import FigureCaption from "../../components/LdsFigureCaption";
import LdsContentSlider from "../../components/LdsContentSlider/LdsContentSlider";
import scan1 from "../../assets/module-2/2-3-5-positive.png";
import scan2 from "../../assets/module-2/2-3-5-negative.png";
import References from "../../components/References";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const scan1alt =
  "Four brain scan images showing different views and color representations, with the word 'Positive' indicating the presence of amyloid plaques. A slider tool below allows viewing the brain from left to right.";
const scan2alt =
  "Four brain scan images showing different views and color representations, with the word 'Negative' indicating the presence of amyloid plaques. A slider tool below allows viewing the brain from left to right.";
// Array to hold the images and alt text
const images = [
  { scan: scan1, alt: scan1alt },
  { scan: scan2, alt: scan2alt },
];

const ImageSlide = ({ src, alt, caption }) => {
  return (
    <div>
      <LdsImage className="content-slider-image" src={src} alt={alt} />
      <FigureCaption
        noCollapse={true}
        className="figcaption-no-border flex-column d-flex"
        radiusSize="small"
      >
        <p className="fz-sm dark-gray">{caption}</p>
      </FigureCaption>
    </div>
  );
};

const getSlides = () => {
  // Array to hold the images
  return images.map((item, index) => (
    <ImageSlide
      key={index}
      src={item.scan}
      alt={item.alt}
      caption="©2016. Avid Radiopharmaceuticals, Inc. All rights reserved. Data on file, Lilly Research Laboratories: AMY20121001F."
    />
  ));
};

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.3.5 Common Challenges to Image Interpretation
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row justify-content-center mt-5">
            <div className="col-8">
              <LdsContentSlider
                contentItems={getSlides()}
                label={
                  "Use the slider tool to view positive and negative scans"
                }
              />
            </div>
          </section>

          <section className="row justify-content-center">
            <div className="col-lg-8 col-sm-12 mt-4 mb-4">
              <h5 className="b">Brain Atrophy and Image Noise</h5>
              <ul className="ms-0">
                <li>
                  Some scans may be difficult to interpret because of image
                  noise, atrophy with a thinned cortical ribbon, or image blur
                </li>
                <li>
                  Significant brain atrophy can affect the anatomical location
                  of the gray-white matter border
                </li>
                <li>
                  If you are uncertain as to the location or edge of gray matter
                  on the PET scan and a co-registered CT image is available,
                  examine the CT image to clarify the relationship of the PET
                  radioactivity and gray matter anatomy
                </li>
              </ul>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-3-4", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-3-6", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <p className="fz-sm gray">
              Amyvid (florbetapir F 18 injection) Prescribing Information. Lilly USA, LLC.
            </p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
